
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".mega-menu__list_c_style2").forEach(menuWrapper => {
    const triggers = menuWrapper.querySelectorAll(".mega-menu__list_left_items_m li a");
    const panels = menuWrapper.querySelectorAll(".collection-panel-style2");

    if (triggers.length && panels.length) {
      // Show first by default
      const firstId = triggers[0].id;
      const firstPanel = menuWrapper.querySelector(`.collection-panel-style2#${firstId}`);
      if (firstPanel) firstPanel.classList.add("active");

      // Hover functionality
      triggers.forEach(trigger => {
        trigger.addEventListener("mouseenter", () => {
          const targetId = trigger.id;

          panels.forEach(panel => panel.classList.remove("active"));
          const matchedPanel = menuWrapper.querySelector(`.collection-panel-style2#${targetId}`);
          if (matchedPanel) matchedPanel.classList.add("active");
        });
      });
    }
  });
});


  document.addEventListener('DOMContentLoaded', function () {
    // Query all Swiper containers dynamically
    document.querySelectorAll('.swiper[class*="megamenuswiper_"]').forEach((swiperEl) => {
      // Skip if already initialized
      if (swiperEl.dataset.initialized === 'true') return;

      new Swiper(swiperEl, {
        slidesPerView: 2,
        spaceBetween: 20,
        navigation: {
          nextEl: '.swiper-button-next-mega',
          prevEl: '.swiper-button-prev-mega',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 3
          },
          1024: {
            slidesPerView: 3
          }
        }
      });

      swiperEl.dataset.initialized = 'true';
    });
  });




// 


 document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.mega-menu-custom-section');

  function hideAllContents() {
    document.querySelectorAll('.mega-menu__content').forEach(content => {
      content.classList.remove('visible');
    });
  }

  sections.forEach(section => {
    const menuItem = section.querySelector('.header__menu-item');
    const content = section.querySelector('.mega-menu__content');

    if (menuItem && content) {
      let timeout;

      // Show menu
      menuItem.addEventListener('mouseenter', () => {
        clearTimeout(timeout);
        hideAllContents();
        content.classList.add('visible');
      });

      // Keep open on content hover
      content.addEventListener('mouseenter', () => {
        clearTimeout(timeout);
      });

      // Hide when leaving both
      menuItem.addEventListener('mouseleave', () => {
        timeout = setTimeout(() => {
          content.classList.remove('visible');
        }, 200);
      });

      content.addEventListener('mouseleave', () => {
        timeout = setTimeout(() => {
          content.classList.remove('visible');
        }, 200);
      });
    }
  });
});




